import React from 'react';
const SearchInputSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g id="Group 20823">
        <path
          id="&#232;&#183;&#175;&#229;&#190;&#132; (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9.99825C0 4.47639 4.47639 0 9.99826 0C15.5201 0 19.9965 4.47639 19.9965 9.99825C19.9965 15.5201 15.5201 19.9965 9.99826 19.9965C4.47639 19.9965 0 15.5201 0 9.99825ZM9.99826 1.62134C5.37183 1.62134 1.62134 5.37183 1.62134 9.99825C1.62134 14.6247 5.37183 18.3752 9.99826 18.3752C14.6247 18.3752 18.3752 14.6247 18.3752 9.99825C18.3752 5.37183 14.6247 1.62134 9.99826 1.62134Z"
          fill={color}
        />
        <path
          id="&#232;&#183;&#175;&#229;&#190;&#132; (Stroke)_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.36759 5.82729C7.29585 4.89909 8.58051 4.32355 9.99805 4.32355C11.4156 4.32355 12.7002 4.89908 13.6285 5.82731C13.9451 6.14389 13.9451 6.65718 13.6285 6.97377C13.3119 7.29035 12.7986 7.29035 12.482 6.97377C11.8454 6.33718 10.9683 5.94489 9.99805 5.94489C9.02778 5.94489 8.15066 6.33718 7.51401 6.97379C7.19741 7.29036 6.68412 7.29034 6.36755 6.97375C6.05097 6.65715 6.05099 6.14386 6.36759 5.82729Z"
          fill={color}
        />
        <path
          id="&#232;&#183;&#175;&#229;&#190;&#132; (Stroke)_3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0302 16.0302C16.3468 15.7136 16.86 15.7136 17.1766 16.0302L21.7625 20.6161C22.0791 20.9327 22.0791 21.4459 21.7625 21.7625C21.4459 22.0791 20.9326 22.0791 20.616 21.7625L16.0302 17.1767C15.7136 16.8601 15.7136 16.3468 16.0302 16.0302Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default SearchInputSVG;
